export type Environment = 'dev' | 'qa' | 'livet' | 'uat' | 'prod';

export const CURRENT_ENV: Environment = 'qa';

// Replace with your actual Google Maps API key (enable Maps JS API + Places API in Google Cloud Console)
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCyki__Z5ssf8Rh2wKRRZPIn190nJIwOLo';

export const API_GATEWAY_BASE_URLS: Record<Environment, string> = {
  dev: 'https://api-test.finap-usa.com',
  qa  :'https://api-qa.finap-usa.com',
  livet: 'http://172.188.207.123',
  uat: 'https://api-uat.finap-usa.com',
  prod:'https://api.finap-usa.com'
};
